import { Button, GridItem } from "@chakra-ui/react";
import React from "react";
import { Spinner } from "@chakra-ui/react";

interface AppointmentProps {
  time: string;
  onSlotPicked: any;
  isSelected: boolean;
  id?: string;
  occupiedDropOff: boolean;
  index?: number;
  isLoading?: boolean;
  isDisabled?: boolean;
  showLoader?: boolean;
}

const Appointment = (props: AppointmentProps) => {
  const { showLoader = false } = props;
  const handleSlotPick = () => {
    if (!props.isDisabled && !props.isLoading && !showLoader) {
      props.onSlotPicked(props);
    }
  };

  return (
    <>
      <Button
        as={GridItem}
        fontWeight="bold"
        w={"100%"}
        cursor={props?.isDisabled ? "not-allowed" : "pointer"}
        onClick={handleSlotPick}
        className={` ${
          props?.isSelected
            ? "tab-btn tab-btn-selected"
            : props?.isDisabled
            ? "tab-btn tab-disabled-btn"
            : "tab-btn tab-btn-available  "
        } ${showLoader ? "mouse-disabled" : ""} `}
        disabled={props?.isDisabled || props?.occupiedDropOff}
        opacity={1}
      >
        {props?.isLoading ? (
          <Spinner color="blue.500" transitionDuration={"0.8s"} />
        ) : (
          <p>{props.time}</p>
        )}
      </Button>
    </>
  );
};

export default Appointment;
